
import { useUI } from "providers/UIProvider"

import { Container } from "@chakra-ui/react"

import Modal from "components/UI/organisms/Modal"
import BookingFeeTabs from "components/templates/SettingsTemplate/BookingFeeTemplate/BookingFeeTabs"
import BookingFeeForm from "components/templates/SettingsTemplate/BookingFeeTemplate/BookingFeeForm"
import useBookingFee from "hooks/useBookingFee"
import { useSettings } from "providers/SettingsProvider/SettingsProvider"
import { BOOKING_FEE_TABS } from "types/shared"

const ReservationCommissionModal = () => {
  const { modals, toggleModal, T } = useUI()
  const { commission, handleChangeCommissionTab } = useSettings()
  const { form: { resetForm } } = useBookingFee()

  return (
    <Modal
      isOpen={modals.reservationCommissionModal.isOpened}
      title={T("laundry.commission.booking_fee")}
      onClose={()=>{
        resetForm()
        handleChangeCommissionTab(commission?.commissionType === 1 ? BOOKING_FEE_TABS.PERCENT : BOOKING_FEE_TABS.FIXED)
        toggleModal("reservationCommissionModal", false)
      }}
      styles={{
        headerPadding: "20px 15px 20px 23px",
        width: "566px",
        bodyPadding: "0px 0px 0px 0px",
      }}
    >
      <Container padding="20px" display="flex" flexDirection="column" alignItems="center">
        <BookingFeeTabs />
        <BookingFeeForm />
      </Container>
    </Modal>
  )
}

export default ReservationCommissionModal